import C3Chart from 'react-c3js'
import React from 'react'
import PropTypes from 'prop-types'

const StateChart = ({ stateName, chart, labels }) => (
  <div className="cmwf--state-change-chart">
    <h2 className="exhibit__title__block">{stateName}<br />
      Health System Performance</h2>
    <C3Chart {...chart} />
    <h3 className="legend__title">Indicator Performance</h3>
    <div className="legend__container">
      <ul className="legend__list">
        <li className="legend__item legend__item__greatly_improved">
        { labels[2].split(": ")[0] }: <strong>{ labels[2].split(": ")[1] }</strong></li>
        <li className="legend__item legend__item__improved">
        { labels[1].split(": ")[0] }: <strong>{ labels[1].split(": ")[1] }</strong></li>
        <li className="legend__item legend__item__no_change">
        { labels[0].split(": ")[0] }: <strong>{ labels[0].split(": ")[1] }</strong></li>
        <li className="legend__item legend__item__worsened">
        { labels[-1].split(": ")[0] }: <strong>{ labels[-1].split(": ")[1] }</strong></li>
        <li className="legend__item legend__item__greatly_worsened">
        { labels[-2].split(": ")[0] }: <strong>{ labels[-2].split(": ")[1] }</strong></li>
      </ul>
    </div>
  </div>
)

StateChart.propTypes = {
  stateName: PropTypes.string.isRequired,
  chart: PropTypes.shape({
    data: PropTypes.object,
  }).isRequired,
}

export default StateChart



// WEBPACK FOOTER //
// ./src/components/Visualizations/components/state-chart.jsx